import styles from './ReferralsSection.module.scss';
import { Button } from 'src/v2/commonComponents/Button';
import { toast } from 'react-toastify';
import { TextDivider } from 'src/v2/commonComponents/TextDivider';
import { ReferralRewardSection } from 'src/v2/components/LeftSidePanel/components/ReferralsSection/components/ReferralRewardSection';
import { ReferralFAQSection } from 'src/v2/components/LeftSidePanel/components/ReferralsSection/components/ReferralFAQSection';
import { useGetReferralsInfo } from 'src/hooks';
import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';

export const ReferralsSection = () => {
  const { url, isReferralsLoading, shouldShowFreeMonths } =
    useGetReferralsInfo();
  const handleCopyClick = () => {
    navigator.clipboard.writeText(url);
    toast.success('Referral link copied');
  };

  if (isReferralsLoading) {
    return (
      <div className={styles.spinnerWrapper}>
        <SpinnerSimple />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {shouldShowFreeMonths && (
        <div className={styles.upsellBlock}>
          <span>
            Get <b>1 FREE MONTH</b> every time a friend subscribes to Ninja!
          </span>
        </div>
      )}
      <div className={styles.referralLinkBlock}>
        <h6 className={styles.title}>Referral link</h6>
        <div className={styles.linkRow}>
          <span className={styles.link}>{url}</span>
          <Button
            onClick={handleCopyClick}
            tooltipContent={`Work Smart. Spend Less. Get your own Ninja! ${url}`}
          >
            Copy link
          </Button>
        </div>
      </div>
      <TextDivider />
      {shouldShowFreeMonths && (
        <>
          <ReferralRewardSection />
          <TextDivider />
        </>
      )}
      <ReferralFAQSection />
    </div>
  );
};
